import React from "react";

const WorkersNeeded = () => {
	return (
    <div>
        <h1>כרגע אין משרות פתוחות</h1>
    </div>
    )
}
export default WorkersNeeded